export const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
export const API_DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE;
